export default function Loader() {
  return (
    <div className="flex justify-center items-center h-40">
      <div className="w-12 h-12 border-[6px] border-gray-200 border-t-main rounded-full animate-spin"></div>
      <span className="text-xs ml-4">Loading...</span>
    </div>
  );
}